import { StaffMember } from 'src/store/sageAdminApi';
import { MessageRecipient } from 'src/store/sageStaffCommsApi';

export const getStaffMemberName = (staffMember?: StaffMember): string =>
    [staffMember?.firstName, staffMember?.lastName].filter(Boolean).join(' ') || 'A staff member';

export const isAgencyStaffAtFacility = (staffMember: StaffMember, facilityId: string) => {
    const staffMemberFacilityConfig = staffMember?.staffMemberFacilityConfigs?.find(
        (facilityConfig) => facilityConfig.facilityId === facilityId
    );

    if (staffMemberFacilityConfig) {
        return !!staffMemberFacilityConfig.isAgencyStaff;
    } else {
        return !!staffMember.isAgencyStaff;
    }
};

export const isOnCallAtFacility = (staffMember: StaffMember, facilityId: string) => {
    const facilityShiftStatus = staffMember?.onCallStates?.find(
        (onCallState) => onCallState.facilityId === facilityId
    );

    if (facilityShiftStatus) {
        return !!facilityShiftStatus.isOnCall;
    } else {
        return false;
    }
};

export const isStaffInCareZone = (
    staffMember: StaffMember,
    facilityId: string,
    careZoneId: string
) => {
    const staffMemberFacilityConfig = staffMember?.staffMemberFacilityConfigs?.find(
        (facilityConfig) => facilityConfig.facilityId === facilityId
    );

    if (staffMemberFacilityConfig) {
        return staffMemberFacilityConfig.careZones?.some((careZone) => careZone?.id === careZoneId);
    } else {
        return false;
    }
};

/**
 * Collects the on-call staff across the given care zones and maps them to message
 * recipients (rid + phone number if avail!)
 */
export const getMessageRecipients = (
    zoneIds: string[],
    onCallStaffByCareZoneRid: Record<string, StaffMember[]>
): MessageRecipient[] => {
    const onCallStaffById = zoneIds.reduce((acc, zoneId) => {
        for (const staffMember of onCallStaffByCareZoneRid[zoneId] ?? []) {
            if (staffMember.id) acc.set(staffMember.id, staffMember);
        }
        return acc;
    }, new Map<string, StaffMember>());

    return Array.from(onCallStaffById.entries()).map(([staffMemberRid, staffMember]) => ({
        staffMemberRid,
        staffMemberPhoneNumber: staffMember.phoneNumber ?? '',
    }));
};
